<div class="contents-area" (dragstart)="onDragstartBody($event)">
  <div>
    <h2>所属情報</h2>
    <div class="column-list">
      <div class="list-input-title" style="width: 100px;">所属</div>
      <div class="list-input-content">
        <app-versatile-combo-box [(ngModel)]="kymw1002Model.supplierCode" [listSource]="kymw1002Model.supplierInfoList"
          valueField="supplierCode" labelField="supplierCodeName" [tabindex]="-1" [visible]="true" [autofocus]="false"
          (change)="supplierCode_CHANGEHandler()" [width]="300">
        </app-versatile-combo-box>
      </div>
    </div>
  </div>

  <div>
    <h2>工程管理情報</h2>
    <div class="message-show-area">
      <ng-template ngFor let-item [ngForOf]="kymw1002Model.dashboardMessageInfoList.ProcessControlList">
        <label class="message-bgc">{{item.PCMessage}}</label><br>
      </ng-template>
    </div>
  </div>

  <div>
    <h2>警告・エラー情報</h2>
    <div class="message-show-area">
      <ng-template ngFor let-item [ngForOf]="kymw1002Model.dashboardMessageInfoList.CautionErrorList">
        <label class="message-bgc">{{item.CEMessage}}</label><br>
      </ng-template>
    </div>
  </div>

  <div>
    <h2>メッセージ</h2>
    <div class="message-show-area">
      <ng-template ngFor let-item [ngForOf]="kymw1002Model.dashboardMessageInfoList.MessageInfoList" let-i="index">
        <div class="message-bgc" [class.message-link]="item.MIFormId!==''"
          id="dashboardMessageLink{{i}}" #dashboardMessageLink{{i}}>
          <label>{{item.MIMessage}}</label>
        </div>
      </ng-template>
    </div>
  </div>

  <div [ngClass]="{invisible: !isAdmin}">
    <h2>ロック情報</h2>
    <div class="block-row">
      <wj-flex-grid #dtg_DashboardLockInfoList id="dtg_DashboardLockInfoList" [headersVisibility]="'Column'"
        [allowSorting]="true" [itemsSource]="kymw1002Model.showDashboardLockInfoList" [allowDragging]="'None'"
        [selectionMode]="'Row'" [isReadOnly]="true" [tabindex]="0" [style.width.px]="955" [style.height.px]="142"
        [style.margin-top]="0" [style.overflow-y]="'auto'"
        (initialized)="initMain(dtg_DashboardLockInfoList)">
        <wj-flex-grid-filter #fltr_Main></wj-flex-grid-filter>
        <wj-flex-grid-column [minWidth]="5" [width]="196" [binding]="'lockFunc'" [header]="'ロック先機能'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'left'">
              {{cell.item.lockFunc}}
            </div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="366" [binding]="'lockTarget'" [header]="'ロック先'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'left'">
              {{cell.item.lockTarget}}
            </div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="150" [binding]="'lockDate'" [header]="'ロック日時'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'left'">
              {{cell.item.lockDate}}
            </div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [width]="226" [binding]="'lockName'" [header]="'ロック実施者'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div [align]="'left'">
              {{cell.item.lockName}}
            </div>
          </ng-template>
        </wj-flex-grid-column>
      </wj-flex-grid>
      <button id="btn_DashboardLockUpdate" #btn_DashboardLockUpdate class="btn-secondary" [tabindex]="0"
        forcedEnabledMode="none" (click)="eventDashboardLockUpdate_CLICKHandler()">更新</button>
    </div>
  </div>

  <div>
    <h2>お知らせ</h2>
    <div>
      <textarea id="txta_dashboardInformation" readonly
        [tabindex]="-1" [(ngModel)]="kymw1002Model.topInfo2"></textarea>
    </div>
  </div>
</div>